// extracted by mini-css-extract-plugin
export default {"card__image":"Card_card__image__yhgrj","card__title":"Card_card__title__0l6OG","card__text":"Card_card__text__co60s"};